import { Chip, Stack, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { getLogCategoryLabel } from '../category-label';

export const LogLine = (props: {
  dateTime: Dayjs;
  description: string;
  userName: string;
  category: string;
  action: string;
}) => {
  const { dateTime, description, userName, category, action } = props;

  return (
    <Stack
      marginY="5px"
      direction="row"
      alignItems="center"
      borderLeft="1px solid red"
      justifyContent="flex-start"
      paddingLeft={1}
    >
      <Stack height="100%">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography fontWeight={600} color="text.primary" fontSize="0.8rem">
            {userName}
          </Typography>
          <Typography variant="h6" color="info.main" fontSize="0.7rem">
            -
          </Typography>
          <Typography variant="caption" color="#ff6221" alignItems="center">
            {dateTime.format('DD.MM.YYYY - HH:mm')}
          </Typography>
          <Chip
            label={getLogCategoryLabel(category)}
            size="small"
            variant="outlined"
            sx={{ height: 20, fontSize: '0.65rem' }}
          />
          <Chip
            label={action}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ height: 20, fontSize: '0.65rem' }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h6" color="info.main" fontSize="0.7rem">
            {description.toUpperCase()}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
